module.exports = {
    HIGH_RISK: {
        name: 'highRisk',
        color: '#ff2c2c',
    },
    MEDIUM_RISK: {
        name: 'mediumRisk',
        color: '#FFA500',
    },
    LOW_RISK: {
        name: 'lowRisk',
        color: '#0BDA51',
    },
    RESIDUAL_RISK: 'residualRisk',
    ANSWER_STATE: {
        YES: 'yes',
        NO: 'no',
        WITHOUTOBJECT: 'withoutObject',
    },
    REDUCER_DANGERS: {
        ADD: 'add',
        UPDATE: 'update',
        DELETE: 'delete',
        RESET: 'reset',
    },
    REDUCER_ACTIONS: {
        ADD: 'add',
        UPDATE: 'update',
        DELETE: 'delete',
        RESET: 'reset',
    },
    REDUCER_INDICATORS: {
        ADD: 'add',
        UPDATE: 'update',
        DELETE: 'delete',
        RESET: 'reset',
    },
}